import { hexToRgb } from '../../../platform/src/helpers/hexToRgb';

export const getCssVarsModel = (settings) => {
    return {
        '--app-color-dark-rgb': !!settings?.backgroundColor ? hexToRgb(settings.backgroundColor) : null,
        '--app-color-light-rgb': !!settings?.textColor ? hexToRgb(settings.textColor) : null,
        '--app-accent-color-rgb': !!settings?.colorAccent ? hexToRgb(settings.colorAccent) : null,
        '--app-border-radius': !!settings?.elementsRoundingSize ? settings.elementsRoundingSize : '4px',
        '--app-secondary-color-light-rgb': !!settings?.cardTextColor ? hexToRgb(settings.cardTextColor) : null,
        '--app-additional-color-rgb': !!settings?.additionalColor ? hexToRgb(settings.additionalColor) : null,
        '--app-additional-border-radius': !!settings?.arrowRoundingSize ? settings.arrowRoundingSize : '24px',
        '--app-border-radius-photo': !!settings?.photoRoundingSize ? settings.photoRoundingSize : '8px',
    }
};
